module.exports = __webpack_public_path__ + "static/img/pres-op--low-colour.50b8c4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/old-services/pres-op--low-colour.png
// module id = UA2R
// module chunks = 1